<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/logo2.png" height="75">
    <ManebiForm class="pt-5"/>
  </div>
</template>

<script>
import ManebiForm from './components/ManebiForm.vue'

export default {
  name: 'App',
  components: {
    ManebiForm
  }
}
</script>

<style>

@font-face {
  font-family: "FunktionalGroteskPro";
  src: local("FunktionalGroteskPro"),   url("./assets/font/FunktionalGroteskPro/FunktionalGroteskPro-Semibold.otf") format("truetype");
}

#app {
  font-family: FunktionalGroteskPro, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #969696;
  margin-top: 60px;
}
</style>
